<template>
  <div class="wrapper">
    <div class="tableBox">
      <div class="tableBox">
        <Table :columns="columns" :data="tableData" v-if="tableData.length">
          <template slot-scope="{ row }" slot="status">
            <span v-show="row.status == '0'">待生效</span>
            <span v-show="row.status == '1'">生效中</span>
            <span v-show="row.status == '2'">已过期</span>
            <span v-show="row.status == '3'">已终止</span>
          </template>
        </Table>
        <div class="text" v-else>
          <span>还未将产品有关协议维护到系统，可到<span class="link" @click="pageTo">【上游协议管理】</span>菜单维护</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
export default {
  props: ['productForm'],
  mixins: [pageTool, common],
  watch: {
    'productForm.id': {
      handler(newVal) {
        if (newVal) {
          this.getGradeList();
        }
      }
    },
    immediate: true,
    deep: true
  },
  data() {
    return {
      isShow: false,
      columns: [
        {
          title: '协议名称',
          align: 'center',
          minWidth: 200,
          tree: true,
          key: 'name',
          className: 'name',
          render(h, params) {
            let text = params.row.name;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text || '-'
                ),
                h('span', { slot: 'content' }, text || '-')
              ]
            );
          }
        },
        {
          title: '协议编号',
          minWidth: 200,
          align: 'center',
          key: 'covenantNo'
        },
        {
          title: '协议类型',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            const covenantLevel = params.row.covenantLevel;
            return <span>{covenantLevel == '1' ? '主协议' : '补充协议'}</span>;
          }
        },
        {
          title: '签约机构',
          minWidth: 150,
          align: 'center',
          key: 'signOrgName'
        },
        {
          title: '签约保司/通道',
          minWidth: 150,
          align: 'center',
          key: 'insuranceCompany',
          render(h, params) {
            return <span>{params.row.insuranceCompany}{params.row.insuranceSupplier}</span>

          }
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          slot:'status',
        },
        {
          title: '有效期',
          minWidth: 220,
          align: 'center',
          render(h, params) {
            const result = params.row.startTime;
            const endTime = params.row.endTime;
            return (
              <span>
                {filters.filterTime(result, 'YYYY-MM-DD') || '-'} 至 {filters.filterTime(endTime, 'YYYY-MM-DD') || '-'}
              </span>
            );
          }
        },
        {
          title: '终止日期',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const result = params.row.stopTime;
            const status = params.row.status;
            if (status === '3') {
              return <span>{filters.filterTime(result, 'YYYY-MM-DD') || '-'}</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
      ],
      searchParams: {
      },
    };
  },
  methods: {
    setListParams(params) {
      params.pageSize = 9999;
      params.productCode = this.productForm.productCode;
      params.covenantSource = '1';
    },
    //查询档次
    getGradeList() {
      this.initListAjax('/buz/covenant/read/list');
    },
    listCallback(res) {},
    pageTo() {
      this.openPageTabTags('/offline/agreementManage/supplierAgreement',{});      
    }
  },
  created() {
    if (this.productForm.id) {
      this.getGradeList();
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  background: #fff;
}
.text {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.link {
  color: #236dff;
  cursor: pointer;
}
</style>
